import { Api } from "./api-client";
export * from "./api.types";
const api = new Api();
api.setup();
export default api;
